import PublicationList from "../components/PublicationList";

const ListPublicationPage = () => {
  return (
    <PublicationList />
  );
};

export default ListPublicationPage;
